export const SUPPORT_CHAT_OPEN_EVENT = 'inmueble:open-support-chat';

export function openSupportChat(): void {
  window.dispatchEvent(new Event(SUPPORT_CHAT_OPEN_EVENT));
}
